import { useState } from "react";
import FaqView from "./view";
import { useNavigate } from "react-router-dom";

export default function Faq() {
	const navigate = useNavigate();

	const [openedAccordion, setOpenedAccordion] = useState<null | number>(null);

	const infos = [
		{
			title: "O que é Free Flow?",
			text: "Free Flow é um novo sistema de pedágio sem praças físicas ou cancela nas rodovias. A identificação do veículo se dá através da captura da placa do carro ou através da TAG  instalada no para-brisa. Ele está em funcionamento em alguns locais desde de 2023 e em expansão pelo Brasil."
		},
		{
			title: "O que é o Pague Free Flow?",
			text: "O Pague Free Flow é um site/app onde você consegue consultar e pagar todas as suas passagens Free Flow. O site/app traz a facilidade de reunir as passagens de todas concessionárias, facilitando a busca e consulta para os usuários, bem como o pagamento."
		},
		{
			title: "Como faço para pagar as tarifas de Free Flow?",
			text: "Caso você tenha a TAG no seu veículo, a cobrança das tarifas são realizadas automaticamente na conta da TAG e você não precisa tomar nenhuma ação. Caso você não tenha TAG, é necessário você consultar suas passagens em portais das concessionárias ou no site/app do Pague Free Flow e realizar o pagamento."
		},
		{
			title: "Como funciona o Free Flow para quem tem TAG?",
			text: "Ter a TAG apresenta vantagens para o usuário do Free Flow porque além de ter a cobrança automática na TAG, o que já traz muita praticidade sem a necessidade de consultar e buscar as tarifas da passagem, os usuários contam ainda com DESCONTO sobre o valor da tarifa."
		},
		{
			title: "Em quanto tempo aparece a cobrança de passagem no freeflow (para clientes sem tag)?",
			text: "O valor da passagem estará disponível para pagamento em até 48 horas após a passagem pelo pórtico na rodovia."
		},
		{
			title: "Qual o prazo para regularização e pagamento das passagens de Free Flow?",
			text: "A tarifa deve ser paga em até 30 dias corridos após a passagem pelo pórtico de cobrança. Para evitar esquecimento do pagamento e perda do prazo, é interessante adquirir uma TAG e ter a cobrança automática."
		},
		{
			title: "Como eu recorro a passagens no freeflow que eu não reconheço?",
			text: `Para resolver passagens não reconhecidas entre em contato com a concessionária da rodovia.
			\n- Telefone Whatsapp/chatbot CCR Rio SP: (11) 2795-2238
			\n- Telefone Whatsapp/chatbot CSG (Caminho das Serras Gaucha): cac@csg.com.br / 0800 122 0240
			\n- Telefone Whatsapp/chatbot EPR (Sul de Minas): https://eprsuldeminas.com.br/fale-conosco / 0800 290 0459
			\n- Telefone Whatsapp/chatbot Econoroeste: https://freeflow.econoroeste.com.br/fale-conosco/
			\n- Telefone Whatsapp/chatbot Tamoios: https://freeflowtamoios.com.br/#faleconosco`
		},
		{
			title: "Dúvidas sobre a multa do Free Flow?",
			text: "O não pagamento da tarifa, em até 30 dias corridos da passagem, está sujeito a multa de trânsito no valor de R$ 195,23 e 5 pontos na carteira (Artigo 209 do Código de Trânsito Brasileiro), além de encargos. A data da infração é referente ao vencimento do pagamento da passagem, ou seja, o trigésimo primeiro dia. No rodapé da notificação da multa encontram-se a data e hora da passagem pelo pórtico de cobrança. Vale lembrar que a multa não desobriga o pagamento da tarifa."
		},
		{
			title: "Tenho desconto da tarifa para usuário frequente?",
			text: "Não, o desconto de usuário frequente é feito exclusivamente para usuários que tem a TAG instalada no veículo, que também possuem o benefício de ter desconto na tarifa de Free Flow."
		},
		{
			title: "Como conseguir o Cupom fiscal?",
			text: "Clique no menu da home do pague freeflow e vá em \"Meus Recibos\". Valide o acesso e clique no recibo que você deseja baixar."
		},
		{
			title: "Como faço uma recarga?",
			text: "A recarga ela poderá ser feita por pix ou cartão de credito dentro do app. Para isso, acesse a carteira na tela inicial, em seguida clique em recarga e selecione a melhor forma de pagamento."
		},
		{
			title: "Quais os contatos das concessionárias que atuam no freeflow?",
			text: `- Telefone Whatsapp/chatbot CCR Rio SP: (11) 2795-2238
			\n- Telefone Whatsapp/chatbot CSG (Caminho das Serras Gaucha): cac@csg.com.br / 0800 122 0240
			\n- Telefone Whatsapp/chatbot EPR (Sul de Minas): https://eprsuldeminas.com.br/fale-conosco / 0800 290 0459
			\n- Telefone Whatsapp/chatbot Econoroeste: https://freeflow.econoroeste.com.br/fale-conosco/
			\n- Telefone Whatsapp/chatbot Tamoios: https://freeflowtamoios.com.br/#faleconosco`
		}
	];

	const goBack = () => navigate(-1);

	const goToContact = () => navigate("/faq/contact");

	return (
		<FaqView
			goBack={goBack}
			openedAccordion={openedAccordion}
			setOpenedAccordion={setOpenedAccordion}
			infos={infos}
			goToContact={goToContact}
		/>
	);
}
